import { GrClose } from "react-icons/gr";
import "../../AppModal/ModalKit.css";

export default function LogoutPopup(props: any) {
  return (
    <div className="fpm-panel fpm-sm">
      <button
        type="button"
        className="fpm-x"
        onClick={() => props.setShowBrokerLogoutPopup(false)}
      >
        <GrClose size={15} />
      </button>
      <div className="fpm-modal">
        <div className="fpm-head">
          <div className="fpm-badge fpm-badge-red">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/><path d="M12 9v4"/><path d="M12 17h.01"/></svg>
          </div>
          <h2>Broker Logout</h2>
        </div>
        <p className="fpm-msg">
          Want to logout from previous selected broker?
        </p>
        <div className="fpm-foot">
          <button
            type="button"
            onClick={() => {props.setLogoutFromPrevBroker("Yes"); props.setShowBrokerLogoutPopup(false);}}
            className="fpm-btn-brand fpm-btn-red"
          >
            Yes
          </button>
          <button
            type="button"
            onClick={() => {props.setLogoutFromPrevBroker("No"); props.setShowBrokerLogoutPopup(false);}}
            className="fpm-btn"
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
}
